import React, { FC, useEffect } from "react";
import { Container, Message } from "semantic-ui-react";

interface IProps {
    title: string | undefined,
    message: string | undefined
}

const ErrorPage: FC<IProps> = ({title, message}) => {

    useEffect(() => {

    }, []);

    return (
        <div className="app">
            <div className="site-content" id="error-content">
                <Container id="error-page" style={{ height: "100%", width: "100%" }}>
                    <div style={{ width: "30%", marginLeft:"30%", justifyContent: "center", alignItems:"center", marginTop: 20 }}>
                        <img src="Images/Robot Inspecting - PNG.png" alt="Error Image" style={{ marginTop: 50, marginLeft: "auto", marginRight:"auto", display: "block" }}></img>
                        <Message icon='exclamation triangle' header='Error' content={`${title} - ${message}`} />
                    </div>
                    
                </Container>
            </div>
        </div>
    );
}

export default ErrorPage;